/* eslint-disable max-params */
import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { FtoReportState } from '../novelty-check-report-state';
import { FtoTaskStep } from '@/domains/fto-report/enums';
import { Logger } from '@patsnap/tahiti-core';
import { FtoReportTaskStatusModel } from '@/domains/fto-report/models/task-status-model';
import type { FtoReportContext } from '../novelty-check-report-context';

@injectable()
export class FtoReportSummaryEndState implements FtoReportState {
    constructor(
        @inject(Logger)
        private readonly _logger: Logger,
        @inject(FtoReportTaskStatusModel)
        private readonly _noveltyCheckTaskStatusModel: FtoReportTaskStatusModel,
    ) { }

    getStep(): FtoTaskStep {
        return FtoTaskStep.SUMMARY_START;
    }

    async enter(): Promise<void> {
        this._logger.info('进入<要点总结展示>状态');
        this._switchTaskStep(FtoTaskStep.SUMMARY_END);
    }

    exit(): Promise<void> {
        this._logger.info('退出<要点总结展示>状态');
        return Promise.resolve();
    }

    async handleNext(context: FtoReportContext): Promise<void> {
        const searchInputState = context.getState(FtoTaskStep.FTO_SEARCH_INPUT);
        await context.transitionTo(searchInputState);
    }

    /**
     * 切换任务步骤
     * @param step 目标步骤
     */
    private _switchTaskStep(step: FtoTaskStep) {
        this._noveltyCheckTaskStatusModel.update(state => {
            state.taskStep = step;
            return state;
        });
    }

    handlePrevious(): Promise<void> {
        this._logger.info('<要点总结展示>状态没有前一个状态');
        return Promise.resolve();
    }
}
